import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100/70 text-primary-700 text-xs font-semibold mb-3">
              焦点专题
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              本周重磅对决专题
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-[600px] mx-auto">
              深度聚焦四大热门PK话题，全方位解析对决背后的故事与看点
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {carouselData.map((item) => (
              <article
                key={item.id}
                className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 hover:border-accent-200 transition-all duration-300 cursor-pointer flex flex-col lg:flex-row"
              >
                <div className="lg:w-[45%] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-[200px] lg:h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="lg:w-[55%] p-5 md:p-6 flex flex-col justify-between">
                  <div>
                    <div className="flex items-center gap-2 mb-3">
                      <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold">
                        {item.tag}
                      </span>
                      <span className="text-xs text-foreground-500">{item.category}</span>
                    </div>
                    <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3 group-hover:text-accent-600 transition-colors">
                      {item.title}
                    </h3>
                    <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3">
                      {item.description}
                    </p>
                  </div>
                  <div className="mt-4 flex items-center justify-between">
                    <span className="text-xs text-foreground-600 font-medium">{item.stats}</span>
                    <span className="flex items-center gap-1 text-accent-500 text-sm font-semibold whitespace-nowrap">
                      查看详情
                      <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}